module.exports = __webpack_public_path__ + "static/media/tyre-red-four2.d2adefb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tyre-red-four2.png
// module id = 338
// module chunks = 0